import { fork, takeEvery, call, put } from 'redux-saga/effects';
import format from 'date-fns/format';
import { teeTimeSearch, preReservation } from './task';
import * as Constants from '../../actions';

function* actionHandler(facilityid) {
    yield takeEvery(Constants.FETCH_TEETIMES, teeTimeSearch)
    yield takeEvery(Constants.CREATE_RESERVATION, preReservation(facilityid))
    yield takeEvery(Constants.TEETIME_UNAVAILIBLE, function*(){
        const date = format(new Date(), 'YYYY-MM-DD')
        const payload = {
            facilityid,
            dateMin: date,
            dateMax: date
        };
        yield put({ type: Constants.FETCH_TEETIMES, payload })
    })
}

function* apiSaga(facilityid) {

    // post content has loaded
    yield put({ type: Constants.CONTENT_LOADED })
    const date = format(new Date(), 'YYYY-MM-DD')
    const payload = {
        facilityid,
        dateMin: date,
        dateMax: date
    };
    yield call(teeTimeSearch, { payload })
    // fork action handler
    yield fork(actionHandler, facilityid);
}

export default apiSaga;



// WEBPACK FOOTER //
// ./src/sagas/api/index.js